import { nbfcDetails, notifyVisitorEvent} from "@Redux/ApplyLoan/action";
import { trackGetNowClicked } from "../../../utils/ga4";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import ElectricImage from "../../../Images/ElectricityImage.png";
import { default as imageInstant } from "../../../Images/Instant.png";
import pendingImage from "../../../Images/PendingIcon.png";
import imageSomeTime from "../../../Images/Personalnew.webp";
import TakesImage from "../../../Images/Takes.png";
import approvedImage from "../../../Images/appproved.png";
import underImage from "../../../Images/duration.png";
import { default as personalIcon } from "../../../Images/personal-loan.png";
import ModalDisbursalDelay from "../../../helper/ModalDisbursalDelay";
import SuperAppToggle from "../Common/SuperAppToggle";

function SuperInstant(props) {
  const {
    credit,
    loanType,
    loanStatus,
    flag,
    event = "loan",
  } = props;

  const [underReview, setUnderReview] = useState(false);
  const [number, setNumber] = useState(3);
  const [timer, setTimer] = useState(24 * 60 * 60);
  const [modalState, setModalState] = useState(false);
  const [statusData, setStatusData] = useState({});
  const [nbfcTat, setNbfcTet] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);
  const [isFromPl] = useState(localStorage.getItem("receivedKey"));
  const [noLimitPreset] = useState();
  
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const navigate = useNavigate();
  const hasCalledNbfcApi = useRef(false);
  const nowTime = new Date();
const userId = props.userDetail?.user_detail?.id; 

  useEffect(() => {

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {

     if( number === 3 && !hasCalledNbfcApi.current){
      hasCalledNbfcApi.current = true;
        props
            .nbfcDetails(token)
            .then((res) => {
              localStorage.setItem(
                "date",
                new Date(res?.data.data.tenure_date).getTime()
              );
              setTimer(Math.abs(new Date(res?.data.data.tenure_date).getTime() - nowTime.getTime()) / 1000);
              setNbfcTet(parseInt(res?.data.data.nbfc_tat));
            })
              .catch(()=>{})
     }

  },[])
  useEffect(() => {
    if (props.documentStatus && props.loanStatusData !== undefined) {
      setStatusData(props.documentStatus);
      setUnderReview(!props.documentStatus.can_apply_for_loan);
      
      if (
        loanStatus?.loan_status === "PASSED" ||
        loanStatus?.loan_status === null
      ) {
        setNumber(4);
        if (!hasCalledNbfcApi.current) {
          hasCalledNbfcApi.current = true;
          props
            .nbfcDetails(token)
            .then((res) => {
              localStorage.setItem(
                "date",
                new Date(res?.data.data.tenure_date).getTime()
              );
              setTimer(Math.abs(new Date(res?.data.data.tenure_date).getTime() - nowTime.getTime()) / 1000);
            })
          .catch(() => {});
        }
      } else if (props.documentStatus.kyc_verified === "VERIFIED") {
        setNumber(3);
      } else {
        setNumber(2);
      }
    }
  }, [props.documentStatus, props.loanStatusData]);
const handleApplyloan = () => { 
    trackGetNowClicked();
    let status_data = props.documentStatus || statusData;
    if (status_data?.blocked) {
      return;
    }
    if (status_data.can_apply_for_loan) {
      if (status_data?.kyc_verified === "NOT_VALID") {
        navigate("/kycnotdone");
        return;
      }
      if (status_data?.kyc_verified === "PENDING_VERIFICATION") {
        navigate("/kycverifyinprogress");
        return;
      }
      if (status_data.bank_details_verified === "NOT_VALID") {
        let bankData = {
          heading: "Sorry !",
          subHeading: "Bank details could not be verified. Please try again",
          message: "",
          but_name: "Try Again",
          route: "bank",
          backbtn: "show",
        };

        navigate(`/not_eligible_for_loan?msg=${JSON.stringify(bankData)}`);
        return;
      }
      if (status_data.bank_details_verified === "PENDING_VERIFICATION") {
        let bankData = {
          heading: "Verifying Details",
          subHeading: "Please try after sometime",
          message: "We're currently in the process of verifying your bank details.",
          but_name: "Back to Home",
          route: "bank",
        };

        navigate(`/message?details=${JSON.stringify(bankData)}`);
      } else {
        navigate(loanType === "P" ? "/apply_loan" : "/personal_loan_emi");
      }
    }
  };
  const eventHandle = () => {
      const payload = {
        event_name: event === "loan" ? "Interacted_Loan_Dashboard" : "Interacted_SuperApp_Dashboard",
        event_body: {
          "Platform": "m-site",
          "Clicked on": "Get Now",
        },
      };
      
      notifyVisitorEvent(payload)
        .then(() => {})
        .catch(() => {});
  };
  const assigninnbfcredirect = ()  =>{
    const payload = {
      event_name: event === "loan" ? "Interacted_Loan_Dashboard" : "Interacted_SuperApp_Dashboard",
      event_body: {
        "Platform": "m-site",
        "Clicked on": "View Status",
      },
    };
    
    notifyVisitorEvent(payload)
      .then(() => {})
      .catch(() => {});

    setTimeout(() => {
      window.location.href = "/nbfc_assigned";
    }, 200);
  };
  const statusHandle = () => {
    const payload = {
      event_name: event === "loan" ? "Interacted_Loan_Dashboard" : "Interacted_SuperApp_Dashboard",
      event_body: {
        "Platform": "m-site",
        "Clicked on": "View Status",
        "User Type": localStorage.getItem("user_type"),
        "Credit Limit amount EMI": localStorage.getItem("emiAmount") ? localStorage.getItem("emiAmount") : 0,
        "Credit Limit amount Payday": localStorage.getItem("paydayAmount") ? localStorage.getItem("paydayAmount") : 0,
        "Loan type EMI": localStorage.getItem("E") ? localStorage.getItem("E") : "",
        "Loan type Payday": localStorage.getItem("P") ? localStorage.getItem("P") : "",
        "Can Apply On": localStorage.getItem("can_apply"),
      },
    };
    
    notifyVisitorEvent(payload)
      .then(() => {})
      .catch(() => {});
  };
  return (
    <div>
      <div
  className={
    !isLargeScreen
      ?  `${(isFromPl && noLimitPreset) ? "" : "superLoanBox status"} pb-18`
      : `${(isFromPl && noLimitPreset) ? "" : " superLoanBoxnew"} pb-18`
  }
>
        {(number !== 4 || flag) && (
          <div className={flag ? "imageSomeTimehere" : "imageInstant"}>
             {(isFromPl && noLimitPreset ) ?
            "":
            <img
              src={
                flag
                  ? imageSomeTime
                  : loanType === "P"
                  ? imageInstant
                  : TakesImage
              }
              height={29}
              width={119}
              alt="some"
            />}
          </div>
        )}
        {number === 4 && !flag && (
          <div className="imageSomeTimehere">
            <img
              src={imageSomeTime}
              height={29}
              width={119}
              alt="personal loan"
            />
          </div>
        )}
        <div className="d-flex flex-row justify-content-between" style={{ marginTop: "-9px" }}>
          {(underReview || !(credit?.credit_limit > 0)) &&
          loanStatus?.loan_status !== "DISBURSED" &&
          loanStatus?.loan_status !== "PASSED" &&
          loanStatus?.loan_status !== null &&
          loanStatus?.loan_status !== "REPAYMENT_AMOUNT" ? (
            <>
             {(isFromPl && noLimitPreset ) ?
            "":
              <div className="loanPart">
                <img src={personalIcon} className="imageLoan" alt="Personal loan icon" />
                <div className="d-flex align-items-center gap-3">
                  <span className="superSpanText">
                    {" "}
                    <span className="rupeEsign"> ₹</span>{" "}
                    {credit?.credit_limit
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                      "10,000".replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  </span>
                  <div className="underSpan">
                    <img width={20} height={20} src={pendingImage} alt="Pending review" />
                    <p className="underP">Under Review </p>
                  </div>
                </div>
              </div>}
            </>
          ) : (
            <>
              {number === 3 ? (
                <div>
                  <div className="loanPart">
                    <div className="loanPartText">
                      <p className="loanCompleteText">
                        <span className="loanSpan">Loan Amount:</span>
                        <span className="loanSpanAmount">
                          &nbsp; <span className="rupeEsign">₹</span>{" "}
                          {credit?.credit_limit
                            ?.toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "10,000"}
                        </span>
                      </p>
                      <div className="divText">
                        Few steps are pending to complete the loan application
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  {number === 4 ? (
                    <div className="loanPart">
                      <div className="loanPartText">
                        <p className="loanCompleteText">
                          <span className="loanSpan">Loan Amount:</span>
                          <span className="loanSpanAmount">
                            &nbsp; ₹{" "}
                            {loanStatus?.amount
                              ?.toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                              "10,000"}
                          </span>
                        </p>
                        <div className="divText">
                          Congrats! Your application is completed.
                        </div>
                        <div className="divSpanText">
                          Your Disbursal is under progress!
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="loanPart">
                      <img src={personalIcon} className="imageLoan" alt="Personal loan icon" />

                      <div className="d-flex align-items-center gap-3">
                        <span className="superSpanText">
                          {" "}
                          <span className="rupeEsign">₹</span>{" "}
                          {credit?.credit_limit
                            ?.toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                            " 2,00,000"}{" "}
                        </span>

                        <div className="aprrovedSpan">
                          <img width={20} height={20} src={approvedImage} alt="Approved" />
                          <p className="approvedP">APPROVED</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <div className="mt13mb8">
          {(underReview || !(credit?.credit_limit > 0)) &&
          loanStatus?.loan_status !== "DISBURSED" &&
          loanStatus?.loan_status !== "PASSED" &&
          loanStatus?.loan_status !== null &&
          loanStatus?.loan_status !== "REPAYMENT_AMOUNT" ? (
            <></>
          ) : (
            <SuperAppToggle number={number} />
          )}
        </div>

        {(underReview || !(credit?.credit_limit > 0)) &&
        loanStatus?.loan_status !== "DISBURSED" &&
        loanStatus?.loan_status !== "PASSED" &&
        loanStatus?.loan_status !== null &&
        loanStatus?.loan_status !== "REPAYMENT_AMOUNT" ? (
          <div className="underPreviewSpan eveluatingprofile">
            {(isFromPl && noLimitPreset) ?
            "":
            <>
            <img height={16} width={16} src={underImage} alt="Under review" />
            <p className="underPText ">
              We're evaluating your details for loan approval. 
            </p>
            </>
            }
          </div>
        ) : (
          <>
            {" "}
            {number !== 4 ? (
              <div
                onClick={() => {
                  eventHandle();
                  handleApplyloan();
                }}
                className="getButton getnowbtnsize">
                <div classNam="superGet ">Get Now </div>
                <img height={22} width={12} src={ElectricImage} alt="Get loan now" />
              </div>
            ) : (
              <>
                {timer > nbfcTat*60*60 ? (
                  <div
                    onClick={() => {
                      statusHandle();
                      setModalState(true);
                    }}
                    className="getButton"
                  >
                    <div classNam="superGet">View Status</div>
                  </div>
                ):
                <div  onClick={()=> {assigninnbfcredirect()}} className="getButton">
                <div classNam="superGet">View Status</div>
                </div>
                }
              </>
            )}
          </>
        )}
      </div>
      <ModalDisbursalDelay
        modalState={modalState}
        setModalState={setModalState}
        loanType={loanType}
        userType={statusData?.user_type}
        canApply={!underReview}
        creditLimit={credit?.credit_limit}
      />
    </div>
  );
}
const mapStateToProps = (state) => ({
  user: state.user,
  userDetail: state.userDetail,
});

export default connect(mapStateToProps, {
  nbfcDetails,
  notifyVisitorEvent,
})(SuperInstant);
